import classnames from "classnames";
import { Grid, List } from "react-feather";
import { ButtonGroup } from "reactstrap";

const NewsHeader = (props) => {
  // ** Props
  const { activeView, setActiveView } = props;

  return (
    <div style={{textAlign:"right"}}>
      <ButtonGroup
        className="btn-group-toggle   "
        style={{
          border: "1px solid #7367f0",
          backgroundColor: "white",
        }}
      >
        <a
          tag="label"
          className={classnames(
            "btn-icon view-btn grid-view-btn  cursor-pointer",
            {
              active: activeView === "grid",
            }
          )}
          color="primary"
          outline="true"
          onClick={() => setActiveView("grid")}
          style={{
            padding: "0.786rem 1.5rem",
            color: "#7367f0",
          }}
        >
          <Grid size={18} />
        </a>
        <a
          tag="label"
          className={classnames("btn-icon view-btn list-view-btn", {
            active: activeView === "list",
          })}
          color="primary"
          outline="true"
          onClick={() => setActiveView("list")}
          style={{
            color: "#7367f0",
            padding: "0.786rem 1.5rem",
          }}
        >
          <List size={18} />
        </a>
      </ButtonGroup>
    </div>
  );
};

export default NewsHeader;
